import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '../../interfaces/table-column.interface';
import { DateFormatterPipe } from '../date/date-formatter.pipe';

@Pipe({
    name: 'tableCell',
    standalone: false
})
export class TableCellPipe implements PipeTransform {

  constructor(private dateFormatterPipe: DateFormatterPipe) {}

  transform(row: any, column: TableColumn): string {
    if (column.fields && Array.isArray(column.fields)) {
      return column.fields
        .map((field) => this.formatValue(this.getNestedValue(row, field), column))
        .filter((value) => value !== undefined && value !== null)
        .join(' ')
        .trim();
    } else if (column.field) {
      return this.formatValue(this.getNestedValue(row, column.field), column) || '';
    }
    return '';
  }

  private getNestedValue(obj: any, field: string): any {
    return field.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj);
  }

  private formatValue(value: any, column: TableColumn, key: string = 'subscription'): string {
    if ((column.field === `${key}.createdAt` || column.field === 'createdAt' || column.field === 'lastSeenAt' || column.field === 'updatedAt' || column.field === 'activatedAt' || column.field === 'expiresAt') && value) {
      return this.dateFormatterPipe.transform(value, 'yyyy-MM-dd HH:mm:ss') || '';
    }
    return value?.toString() || ''; 
  }

}
